import { Position } from '@iotv/iotv-v3-types'
import circle from '@turf/circle'
import { featureCollection, lineString, points, polygon } from '@turf/helpers'
import { angle, buffer, center, difference, distance, midpoint, transformTranslate } from '@turf/turf'
import { Position as TurfPosition } from 'geojson'
import { EffluentPath, EffluentSpreaderHelper } from '../../../../datamodel/src'

export const convertLineTypePathToArea = (line: Position[], throwRadius: number | undefined): Position[] | undefined => {
  if (throwRadius === undefined) {
    return undefined
  }

  let boundary = EffluentSpreaderHelper.getLineBoundaries(line, throwRadius)
  let pathing = boundary?.geometry.coordinates[0]
  let area = EffluentSpreaderHelper.convertTurfToPosition(pathing!)

  return area
}

export const covertLateralPathToArea = (
  line: Position[],
  throwRadius: number | undefined,
  radius: number | undefined,
  basis?: EffluentPath,
): Position[] | undefined => {
  if (throwRadius === undefined || radius === undefined) {
    return undefined
  }
  if (radius === 0) {
    return convertLineTypePathToArea(line, throwRadius)
  }

  let north: TurfPosition = [line[0].lng, line[0].lat + 1]
  let start: TurfPosition = [line[0].lng, line[0].lat]
  let end: TurfPosition = [line[line.length - 1].lng, line[line.length - 1].lat]

  let angleDiff = angle(north, start, end)

  let angleLine = lineString([north, start, end])
  // if (booleanClockwise(angleLine)) {
  //   angleDiff = 360 - angleDiff;
  // }
  // same point, a horizontal lines gets created
  // if too close
  let lineDiff = distance(start, end, { units: 'meters' })
  let isSmallType = lineDiff < throwRadius

  if (isSmallType && basis && basis.path && basis.path.length > 0) {
    // if (lineDiff < 10 && basis && basis.path && basis.path.length > 0) {
    let extreme = EffluentSpreaderHelper.convertPositionToTurf(basis.path)
    let mid = midpoint(extreme[0], extreme[1]).geometry.coordinates
    let diffAngle = angle(north, start, mid)
    let diffAngleLine = lineString([north, start, mid])
    // if (booleanClockwise(diffAngleLine)) {
    //   diffAngle = 360 - diffAngle;
    // }
    angleDiff = diffAngle
  }

  let baseArea = [start, end, end, start]

  let areaed = polygon([baseArea])

  // setup line as an 'area'
  let topArea = transformTranslate(areaed, radius / 2, angleDiff - 90, {
    units: 'meters',
  }).geometry.coordinates[0].slice(0, 2)
  let bottomArea = transformTranslate(areaed, radius / 2, angleDiff + 90, {
    units: 'meters',
  }).geometry.coordinates[0].slice(0, 2)

  let combined = [...topArea, bottomArea[1], bottomArea[0], topArea[0]]

  if (isSmallType) {
    let polygoned = polygon([combined])
    let withBuffer = buffer(polygoned, throwRadius, { units: 'meters' })?.geometry.coordinates[0]
    if (withBuffer) {
      return EffluentSpreaderHelper.convertTurfToPosition(withBuffer)
    }
  }

  return EffluentSpreaderHelper.convertTurfToPosition(combined)
}

const getLinedPositionExtreams = (linePos: Position[]): [start: TurfPosition, end: TurfPosition] => {
  // current implementation does not require it, but for safety
  if (linePos.length < 2) {
    return [
      [0, 0],
      [0, 0],
    ]
  }

  // get center
  const turfedLine = EffluentSpreaderHelper.convertPositionToTurf(linePos)

  // const centerPoint = centroid(polygon([turfedLine])).geometry.coordinates;
  const centerPoint = center(points(turfedLine)).geometry.coordinates

  const posDist = turfedLine
    .map((pos) => {
      let len = distance(centerPoint, pos)

      return { position: pos, distance: len }
    })
    .sort((a, b) => b.distance - a.distance)

  const firstExtreme = posDist[0].position

  // recalculate using the extreeme
  const posDist2nd = turfedLine
    .map((pos) => {
      let len = distance(firstExtreme, pos)

      return { position: pos, distance: len }
    })
    .sort((a, b) => b.distance - a.distance)

  const secondExtreme = posDist2nd[0].position

  // shouldn't be required, but to be safe
  return [firstExtreme, secondExtreme]
}

export const covertLateralPathToAreaV2 = (
  line: Position[],
  throwRadius: number | undefined,
  radius: number | undefined,
  basis?: EffluentPath,
): Position[] | undefined => {
  if (throwRadius === undefined || radius === undefined) {
    return undefined
  }
  if (radius === 0) {
    return convertLineTypePathToArea(line, throwRadius)
  }

  const [start, end] = getLinedPositionExtreams(line)

  // let start: TurfPosition = [line[0].lng, line[0].lat];
  // let end: TurfPosition = [line[line.length - 1].lng, line[line.length - 1].lat];

  let north: TurfPosition = [start[0], start[1] + 1]

  let angleDiff = angle(north, start, end)

  let angleLine = lineString([north, start, end])
  // if (booleanClockwise(angleLine)) {
  //   angleDiff = 360 - angleDiff;
  // }
  // same point, a horizontal lines gets created
  // if too close
  let lineDiff = distance(start, end, { units: 'meters' })
  let isSmallType = lineDiff < throwRadius

  if (isSmallType && basis && basis.path && basis.path.length > 0) {
    // if (lineDiff < 10 && basis && basis.path && basis.path.length > 0) {
    let extreme = EffluentSpreaderHelper.convertPositionToTurf(basis.path)
    let mid = midpoint(extreme[0], extreme[1]).geometry.coordinates
    let diffAngle = angle(north, start, mid)
    let diffAngleLine = lineString([north, start, mid])
    // if (booleanClockwise(diffAngleLine)) {
    //   diffAngle = 360 - diffAngle;
    // }
    angleDiff = diffAngle
  }

  let baseArea = [start, end, end, start]

  let areaed = polygon([baseArea])

  // setup line as an 'area'
  let topArea = transformTranslate(areaed, radius / 2, angleDiff - 90, {
    units: 'meters',
  }).geometry.coordinates[0].slice(0, 2)
  let bottomArea = transformTranslate(areaed, radius / 2, angleDiff + 90, {
    units: 'meters',
  }).geometry.coordinates[0].slice(0, 2)

  let combined = [...topArea, bottomArea[1], bottomArea[0], topArea[0]]

  if (isSmallType) {
    let polygoned = polygon([combined])
    let withBuffer = buffer(polygoned, throwRadius, { units: 'meters' })?.geometry.coordinates[0]
    if (withBuffer) {
      return EffluentSpreaderHelper.convertTurfToPosition(withBuffer)
    }
  }

  return EffluentSpreaderHelper.convertTurfToPosition(combined)
}

export const convertPointTypePathToArea = (line: Position[], range: number | undefined, throwRadius: number | undefined): Position[] | undefined => {
  if (range === undefined || throwRadius === undefined) {
    return undefined
  }
  let point = EffluentSpreaderHelper.convertPositionToTurf(line)
  if (throwRadius === 0) {
    let pointCoverage = circle(point[0], range, { units: 'meters' })
    return EffluentSpreaderHelper.convertTurfToPosition(pointCoverage.geometry.coordinates)
  } else {
    // has a radius
    let circleLineBig = circle(point[0], throwRadius + range, {
      units: 'meters',
    })
    let circleLineSmall = circle(point[0], throwRadius - range, {
      units: 'meters',
    })

    let ring = difference(featureCollection([circleLineBig, circleLineSmall]))
    if (ring?.geometry.coordinates.length === 2) {
      let ring1 = EffluentSpreaderHelper.convertTurfToPosition(ring?.geometry.coordinates[0])
      let ring2 = EffluentSpreaderHelper.convertTurfToPosition(ring?.geometry.coordinates[1])
      let combined = [...ring1, ...ring2, ring1[0]]

      return combined
    } else if (ring?.geometry.coordinates.length === 1) {
      // when there is no hole in the middle
      let pointArea = EffluentSpreaderHelper.convertTurfToPosition(ring?.geometry.coordinates[0])
      return pointArea
    }
  }

  return convertLineTypePathToArea(line, range)
}
